
export enum ValueBalanceType
{
    Costs = 'Costs',
    Benefits = 'Benefits',
    Net = 'Net',
}

export enum ValueCommitmentType
{
    Total = 'Total',
    Committed = 'Committed',
    Tentative ='Tentative'
}
